<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->

		<div class="RefreshGrid">
			<label>Refresh Every</label>
			<input type="number" [min]="MinimumRefreshSeconds" [(ngModel)]="RefreshSeconds" (ngModelChange)="onRefreshSecondsChange($event)" />
			<label>seconds</label>
		</div>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstBus"
		[loading]="PreferenceLoading == true"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedBus"
		dataKey="BusID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th class="ButtonWidth"></th>

				<!--INSERT CUSTOM FILTERS HERE-->

				<!--BusNbr-->
				<th>
					<p-columnFilter type="text" field="BusNbr" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--BusDesc-->
				<th>
					<p-columnFilter type="text" field="BusDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--BusRouteNbr-->
				<th>
					<p-columnFilter type="text" field="BusRouteNbr" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--BusRouteTypeDesc-->
				<th>
					<p-columnFilter field="BusRouteTypeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterBusRouteTypeDesc
								[ngModel]="value"
								[options]="lstBusRouteTypeDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--DriverName-->
				<th>
					<p-columnFilter type="text" field="DriverName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StudentCount-->
				<th>
					<!-- <p-columnFilter type="text" field="StudentCount" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--UnassignedCount-->
				<th>
					<!-- <p-columnFilter type="text" field="UnassignedCount" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--LastUpdated-->
				<th>
					<!-- <p-columnFilter type="text" field="LastUpdated" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--AlertDesc-->
				<th>
					<p-columnFilter type="text" field="AlertDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SeverityDesc-->
				<th>
					<p-columnFilter field="SeverityDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSeverityDesc
								[ngModel]="value"
								[options]="lstSeverityDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th class="ButtonWidth"></th>

				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="BusNbr">Bus<p-sortIcon field="BusNbr"></p-sortIcon></th>
				<th pSortableColumn="BusDesc">Description<p-sortIcon field="BusDesc"></p-sortIcon></th>
				<th pSortableColumn="BusRouteNbr">Route<p-sortIcon field="BusRouteNbr"></p-sortIcon></th>
				<th pSortableColumn="BusRouteTypeDesc">Route Type<p-sortIcon field="BusRouteTypeDesc"></p-sortIcon></th>
				<th pSortableColumn="DriverName">Driver<p-sortIcon field="DriverName"></p-sortIcon></th>
				<th pSortableColumn="StudentCount">Students<p-sortIcon field="StudentCount"></p-sortIcon></th>
				<th pSortableColumn="UnassignedCount">Unassigned Students<p-sortIcon field="UnassignedCount"></p-sortIcon></th>
				<th pSortableColumn="LastUpdated">Last Updated<p-sortIcon field="LastUpdated"></p-sortIcon></th>
				<th pSortableColumn="AlertDesc">Alert<p-sortIcon field="AlertDesc"></p-sortIcon></th>
				<th pSortableColumn="Severity">Severity<p-sortIcon field="Severity"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Bus>
			<tr [pSelectableRow]="Bus" (dblclick)="onRowDblClick(Bus)">
				<td class="ButtonWidth">
					<button *ngIf="Bus.DisplayDetails != true" class="btn btn-success" style="margin: 0px" (click)="onExpand(Bus)">
						<i class="fa fa-plus" style="color: white" aria-hidden="true"></i>
					</button>
					<button *ngIf="Bus.DisplayDetails == true" class="btn btn-danger" style="margin: 0px" (click)="onExpand(Bus)">
						<i class="fa fa-minus" style="color: white" aria-hidden="true"></i>
					</button>
				</td>

				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Bus[col.field] }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="Bus.HasAlert == true ? 'Red' : 'Black'">
					{{ Bus.AlertDesc }}
				</td>

				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="Bus.HasAlert == true ? 'Red' : 'Black'">
					{{ Bus.SeverityDesc }}
				</td>
			</tr>

			<tr *ngIf="Bus.DisplayDetails == true">
				<td colspan="11">
					<caass-bus-overview-student-table [lstStudents]="Bus.lstStudents"> </caass-bus-overview-student-table>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
